module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.article != null) ? _c('div', [_c('alert-message', {
    attrs: {
      "type": "success",
      "message": _vm.successMessage,
      "timeout": 5000
    }
  }), _vm._v(" "), _c('alert-message', {
    attrs: {
      "type": "danger",
      "errors": _vm.errors
    }
  }), _vm._v(" "), _vm._l((_vm.blocksSorted), function(b, idx) {
    return _c('div', [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showBlockControl(b)),
        expression: "showBlockControl(b)"
      }],
      staticClass: "row"
    }, [_c('hr'), _vm._v(" "), _c('div', {
      staticClass: "span12"
    }, [_c('button', {
      staticClass: "btn btn-mini btn-danger",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.remove(idx)
        }
      }
    }, [_c('span', {
      staticClass: "icon-trash icon-white"
    })]), _vm._v(" "), _c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showUp(idx)),
        expression: "showUp(idx)"
      }],
      staticClass: "btn btn-mini btn-primary",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.moveUp(idx)
        }
      }
    }, [_c('span', {
      staticClass: "icon-arrow-up icon-white"
    })]), _vm._v(" "), _c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showDown(idx)),
        expression: "showDown(idx)"
      }],
      staticClass: "btn btn-mini btn-primary",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.moveDown(idx)
        }
      }
    }, [_c('span', {
      staticClass: "icon-arrow-down icon-white"
    })])])]), _vm._v(" "), (b.block == 0) ? _c('block-text', {
      attrs: {
        "label": "Titulek",
        "index": idx,
        "text": b.title
      },
      on: {
        "update:text": function($event) {
          _vm.$set(b, "title", $event)
        }
      }
    }) : _vm._e(), _vm._v(" "), (b.block == 21) ? _c('block-text', {
      attrs: {
        "label": "SEO Title",
        "index": idx,
        "text": b.title
      },
      on: {
        "update:text": function($event) {
          _vm.$set(b, "title", $event)
        }
      }
    }) : _vm._e(), _vm._v(" "), (b.block == 20) ? _c('block-text', {
      attrs: {
        "label": "SEO Description",
        "index": idx,
        "text": b.description
      },
      on: {
        "update:text": function($event) {
          _vm.$set(b, "description", $event)
        }
      }
    }) : _vm._e(), _vm._v(" "), (b.block == 22) ? _c('block-text', {
      attrs: {
        "label": "SEO Keywords",
        "index": idx,
        "text": b.keywords
      },
      on: {
        "update:text": function($event) {
          _vm.$set(b, "keywords", $event)
        }
      }
    }) : _vm._e(), _vm._v(" "), (b.block == 30) ? _c('block-html', {
      attrs: {
        "label": "Blok textu",
        "index": idx,
        "html": b.html
      },
      on: {
        "update:html": function($event) {
          _vm.$set(b, "html", $event)
        }
      }
    }) : _vm._e(), _vm._v(" "), (b.block == 40) ? _c('block-image', {
      attrs: {
        "label": "Obrázek",
        "index": idx,
        "image": b.image
      },
      on: {
        "update:image": function($event) {
          _vm.$set(b, "image", $event)
        }
      }
    }) : _vm._e(), _vm._v(" "), (b.block == 50) ? _c('block-gallery', {
      attrs: {
        "label": "Galerie obrázků",
        "index": idx,
        "images": b.images
      },
      on: {
        "update:images": function($event) {
          _vm.$set(b, "images", $event)
        }
      }
    }) : _vm._e(), _vm._v(" "), (b.block == 60) ? _c('block-html', {
      attrs: {
        "label": "Citát (černý)",
        "index": idx,
        "html": b.html
      },
      on: {
        "update:html": function($event) {
          _vm.$set(b, "html", $event)
        }
      }
    }) : _vm._e(), _vm._v(" "), (b.block == 61) ? _c('block-html', {
      attrs: {
        "label": "Citát (šedý)",
        "index": idx,
        "html": b.html
      },
      on: {
        "update:html": function($event) {
          _vm.$set(b, "html", $event)
        }
      }
    }) : _vm._e(), _vm._v(" "), (b.block == 62) ? _c('block-html', {
      attrs: {
        "label": "Citát (oranžový)",
        "index": idx,
        "html": b.html
      },
      on: {
        "update:html": function($event) {
          _vm.$set(b, "html", $event)
        }
      }
    }) : _vm._e(), _vm._v(" "), (b.block == 70) ? _c('block-text', {
      attrs: {
        "label": "Osoba u reference",
        "index": idx,
        "text": b.person
      },
      on: {
        "update:text": function($event) {
          _vm.$set(b, "person", $event)
        }
      }
    }) : _vm._e(), _vm._v(" "), (b.block == 70) ? _c('block-html', {
      attrs: {
        "label": "Popis reference",
        "index": idx,
        "html": b.html
      },
      on: {
        "update:html": function($event) {
          _vm.$set(b, "html", $event)
        }
      }
    }) : _vm._e(), _vm._v(" "), (b.block == 70) ? _c('block-check', {
      attrs: {
        "label": "Viditelná",
        "index": idx,
        "val": b.isVisible
      },
      on: {
        "update:val": function($event) {
          _vm.$set(b, "isVisible", $event)
        }
      }
    }) : _vm._e(), _vm._v(" "), (b.block == 70) ? _c('block-gallery', {
      attrs: {
        "label": "Galerie u reference",
        "index": idx,
        "images": b.images
      },
      on: {
        "update:images": function($event) {
          _vm.$set(b, "images", $event)
        }
      }
    }) : _vm._e(), _vm._v(" "), (b.block == 70) ? _c('block-attachment', {
      attrs: {
        "label": "Příloha u reference",
        "index": idx,
        "attachment": b.attachment
      },
      on: {
        "update:attachment": function($event) {
          _vm.$set(b, "attachment", $event)
        }
      }
    }) : _vm._e(), _vm._v(" "), (b.block == 80) ? _c('block-text', {
      attrs: {
        "label": "Titulek",
        "index": idx,
        "text": b.title
      },
      on: {
        "update:text": function($event) {
          _vm.$set(b, "title", $event)
        }
      }
    }) : _vm._e(), _vm._v(" "), (b.block == 80) ? _c('block-text', {
      attrs: {
        "label": "Podtitulek",
        "index": idx,
        "text": b.subTitle
      },
      on: {
        "update:text": function($event) {
          _vm.$set(b, "subTitle", $event)
        }
      }
    }) : _vm._e(), _vm._v(" "), (b.block == 80) ? _c('block-text', {
      attrs: {
        "label": "Magazín",
        "index": idx,
        "text": b.magazine
      },
      on: {
        "update:text": function($event) {
          _vm.$set(b, "magazine", $event)
        }
      }
    }) : _vm._e(), _vm._v(" "), (b.block == 80) ? _c('block-text', {
      attrs: {
        "label": "Datum",
        "index": idx,
        "text": b.date
      },
      on: {
        "update:text": function($event) {
          _vm.$set(b, "date", $event)
        }
      }
    }) : _vm._e(), _vm._v(" "), (b.block == 80) ? _c('block-html', {
      attrs: {
        "label": "Popis článku",
        "index": idx,
        "html": b.html
      },
      on: {
        "update:html": function($event) {
          _vm.$set(b, "html", $event)
        }
      }
    }) : _vm._e(), _vm._v(" "), (b.block == 80) ? _c('block-gallery', {
      attrs: {
        "label": "Galerie u článku",
        "index": idx,
        "images": b.images
      },
      on: {
        "update:images": function($event) {
          _vm.$set(b, "images", $event)
        }
      }
    }) : _vm._e(), _vm._v(" "), (b.block == 80) ? _c('block-attachment', {
      attrs: {
        "label": "Příloha u článku",
        "index": idx,
        "attachment": b.attachment
      },
      on: {
        "update:attachment": function($event) {
          _vm.$set(b, "attachment", $event)
        }
      }
    }) : _vm._e()], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newBlockId),
      expression: "newBlockId"
    }],
    staticClass: "m-t-20",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.newBlockId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    },
    model: {
      value: (_vm.newBlockId),
      callback: function($$v) {
        _vm.newBlockId = $$v
      },
      expression: "newBlockId"
    }
  }, [_vm._v("-- nový blok --")]), _vm._v(" "), _vm._l((_vm.newBlocks), function(nb) {
    return _c('option', {
      domProps: {
        "value": nb.id
      }
    }, [_vm._v(_vm._s(nb.name))])
  })], 2)]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning",
    attrs: {
      "disabled": _vm.newBlockId == null
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addBlock($event)
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-plus"
  }), _vm._v(" Přidat blok")]), _vm._v(" "), _c('div', {
    staticClass: "form-group m-t-20"
  }, [_c('button', {
    staticClass: "btn btn-success btn-large",
    attrs: {
      "disable": _vm.working
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.saveArticle($event)
      }
    }
  }, [_vm._v("ULOŽIT")])])], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66ba8446","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./Content/Modern/js/vue/admin-article.vue
// module id = 118
// module chunks = 1